// Styles
import './hero-slideshow.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeroSlideshow = (context) => {
  const heroSlideshowSection = context.closest('.shopify-section');

  if (heroSlideshowSection) {
    const slidesContainer = heroSlideshowSection.querySelector('.hero-slideshow__container');
    const slides = slidesContainer.querySelectorAll('.swiper-wrapper .hero-slideshow__slide');
    const slidesCount = slides.length;
    var PageHeader;

    slides.forEach(slide => {
      slide.addEventListener('click', e => {
        if (e.target.dataset.slideRedirect) {
          location.href = e.target.dataset.slideRedirect;
        }
      });
    });

    if (window.innerWidth > 768) {
      PageHeader = document.querySelector('#header-announcement-container #shopify-section-announcement-bar');
    } else {
      PageHeader = document.querySelector('#header-announcement-container .site-header');
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth > 768) {
        PageHeader = document.querySelector('#header-announcement-container #shopify-section-announcement-bar');
      } else {
        PageHeader = document.querySelector('#header-announcement-container .site-header');
      }
    });

    if (slidesCount > 1) {
      const swiper = new Swiper(heroSlideshowSection.querySelector('.hero-slideshow__container'), {
        loop: true,

        pagination: {
          el: heroSlideshowSection.querySelector('.hero-slideshow__dots'),
          clickable: true
        },

        navigation: {
          nextEl: heroSlideshowSection.querySelector('.hero-slideshow__arrow.right'),
          prevEl: heroSlideshowSection.querySelector('.hero-slideshow__arrow.left'),
        },
      });
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.hero-slideshow__container'), (el) => {
    window.dAgency.initHeroSlideshow(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.hero-slideshow__container'), (el) => {
      window.dAgency.initHeroSlideshow(el);
    });
  });
}
